import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { PhotoReplacement } from '../ai-image-edit-overlay/ai-image-edit-overlay.component';

export interface DescriptionImage {
  index: number;
  url: string;
  thumbnailUrl: string;
}

export interface DescriptionImageUpdateEvent {
  oldUrl: string;
  newUrl: string;
  updatedHtml: string;
}

@Component({
  selector: 'description-image-editor',
  templateUrl: './description-image-editor.component.html',
  styleUrls: ['./description-image-editor.component.scss'],
})
export class DescriptionImageEditorComponent implements OnChanges {
  @Input() descriptionHtml: string;
  @Input() isAdminPage = false;

  @Output() descriptionUpdated = new EventEmitter<DescriptionImageUpdateEvent>();

  images: DescriptionImage[] = [];
  isExpanded = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.descriptionHtml) {
      this.extractImages();
    }
  }

  /**
   * HTML에서 이미지 추출
   */
  private extractImages(): void {
    if (!this.descriptionHtml) {
      this.images = [];
      return;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(this.descriptionHtml, 'text/html');
    const imgElements = doc.querySelectorAll('img');

    this.images = Array.from(imgElements).map((img, index) => ({
      index,
      url: img.src,
      thumbnailUrl: img.src,
    }));
  }

  /**
   * 인덱스 기반 이미지 업데이트 핸들러 (Option C)
   */
  onImageUpdatedByIndex(index: number, replacement: PhotoReplacement): void {
    const newUrl = replacement.newUrl;
    const image = this.images[index];
    if (!image) return;

    const oldUrl = image.url;

    // HTML 내의 이미지 URL 업데이트
    const updatedHtml = this.updateImageInHtml(oldUrl, newUrl);

    // 로컬 상태 업데이트
    image.url = newUrl;
    image.thumbnailUrl = newUrl;

    // 이벤트 발생
    this.descriptionUpdated.emit({
      oldUrl,
      newUrl,
      updatedHtml,
    });
  }

  /**
   * HTML 내의 이미지 URL 교체
   */
  private updateImageInHtml(oldUrl: string, newUrl: string): string {
    if (!this.descriptionHtml) return '';

    // 이스케이프된 특수문자 처리를 위해 정규식 사용
    const escapedOldUrl = oldUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`src=["']${escapedOldUrl}["']`, 'g');

    return this.descriptionHtml.replace(regex, `src="${newUrl}"`);
  }

  /**
   * 이미지 키 생성
   */
  getImageKey(index: number): string {
    return `desc-img-${index}`;
  }

  /**
   * 아코디언 토글
   */
  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }
}
